export default "__VITE_ASSET__B7Y2$o79__"